import { render, staticRenderFns } from "./MessageBoxV2.vue?vue&type=template&id=c19d5b6e&scoped=true"
import script from "./MessageBoxV2.vue?vue&type=script&lang=js"
export * from "./MessageBoxV2.vue?vue&type=script&lang=js"
import style0 from "./MessageBoxV2.vue?vue&type=style&index=0&id=c19d5b6e&prod&scoped=true&lang=css"
import style1 from "./MessageBoxV2.vue?vue&type=style&index=1&id=c19d5b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19d5b6e",
  null
  
)

export default component.exports